module.exports = __webpack_public_path__ + "prod/1.42.2/img/submitSus.8e6977d5.png";